<div class="out">
  <div class="color" [style.background]="color">
  </div>
  <!-- <input kzInput[(colorPicker)]="value" [style.background]="value" /> -->
  <input kzInput #input class="tx" placeholder="#8F5DFF" [(ngModel)]="color" (ngModelChange)="modelChanged($event)">
</div>
